import { environment } from './../environments/environment';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: any;
  api_url = environment.api_endpoint;
  viewCityObj: any = {};
  viewDistrictObj: any = {};
  viewFacilityObj: any = {};
  viewVillageObj: any = {};
  resetObj: any;
  public userResetInfo: any;
  constructor(
    private router: Router,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {}

  downloadFile(path: string): Observable<any> {
    return this.http.get(`${this.api_url}${path}`, {
      responseType: 'blob',
    });
  }

  downloadTemplate(path: string): void {
    this.http
      .get(`${this.api_url}template/${path}`, {
        responseType: 'blob',
      })
      .subscribe((res) => {
        let blob: any = new Blob([res]);
        FileSaver.saveAs(blob, `${path}-template.xlsx`);
      });
  }

  getIsAuth(): boolean {
    return localStorage.getItem('jwt_token') ? true : false;
  }

  getToken() {
    return localStorage.getItem('jwt_token') || '';
  }
  getToken_forgotPassword() {
    return JSON.parse(localStorage.getItem('forgotPassword_token') || '');
  }

  getUserId() {
    return localStorage.getItem('userId');
  }

  isLoggedIn() {
    if (typeof this.getToken() === 'string' && this.getToken().length > 10)
      return true;
    else return false;
  }

  logout() {
    localStorage.clear();
    this.snackBar.open('You have been successfully logged out!', '', {
      duration: 5000,
    });
    this.router.navigate(['login']);
    this.spinner.hide();
  }
  //refresh token
  refreshToken(): Observable<any> {
    const refToken = localStorage.getItem('refToken') || '';
    return this.http
      .put<any>(
        `${this.api_url}refresh-token`,
        { refreshToken: refToken },
        { observe: 'response' }
      )
      .pipe(
        tap((res: any) => {
          const token = res.headers.get('authorization');
          const refToken = res.headers.get('refreshToken');
          localStorage.setItem('jwt_token', token);
          localStorage.setItem('refToken', refToken);
        }),
        catchError((err: any) => {
          if (err.status === 501) {
            localStorage.clear();
            this.router.navigate(['login']);
            this.snackBar.open('Login expired please login again!', '', {
              duration: 5000,
            });
          }
          return throwError(EMPTY);
        })
      );
  }

  // user login
  user_login(data: any) {
    return this.http
      .post(this.api_url + 'login', data, {
        observe: 'response',
      })
      .pipe(map((data) => data));
  }

  // forgot password
  forgot_password(path: any, obj?: any) {
    return this.http.post(this.api_url + path, obj).pipe(map((data) => data));
  }
  send_code(path: any, obj: any): Observable<any> {
    return this.http.post(this.api_url + path, obj);
  }

  validate_otp(obj: any): Observable<any> {
    return this.http.post(this.api_url + 'validate-otp', obj, {
      observe: 'response',
    });
  }

  //reset password

  resetPassword(data: any, userid: any) {
    const path = 'forgot-password';
    return this.http.post(this.api_url + path, data).pipe(map((data) => data));
  }

  change_password(data: any) {
    const path = 'user/password';
    return this.http.put(this.api_url + path, data).pipe(map((data) => data));
  }

  apiPost(path: any, body: any) {
    return this.http.post(this.api_url + path, body).pipe(
      map(
        (data) => data,
        (error: any) => Observable.throw(error)
      )
    );
  }

  apiCountryConf(body: any) {
    return this.http
      .post(this.api_url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: this.getToken(),
        }),
      })
      .pipe(
        map(
          (data) => data,
          (error: any) =>
            // console.log(error)
            Observable.throw(error)
        )
      );
  }

  apiPut(path: string, body: any) {
    return this.http.put(this.api_url + path, body).pipe(
      map(
        (data) => data,
        (error: any) => Observable.throw(error)
      )
    );
  }

  apiDelete(path: string, token: string) {
    const headerVal: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-access-token': token,
      }),
    };
    return this.http.delete(this.api_url + path, headerVal).pipe(
      map(
        (data) => data,
        (error: any) =>
          // console.log(error)
          Observable.throw(error)
      )
    );
  }
  // Common get API
  apiGet(path: any, data: any) {
    return this.http.get(this.api_url + path);
  }
  apiGetWithParams(path: any, data: any) {
    return this.http.get(this.api_url + path, { params: data });
  }
  //For template download
  templateGet(path: any, data: any) {
    return this.http.get(this.api_url + path);
  }
}
